<template>
  <div>
    <div class="box-header-table text-right mb-3 d-flex justify-content-end gap-3">
      <Button label="Reject" @click="actionReject" :disabled="!canReject" />
      <Button label="Accept" @click="actionAccept" :disabled="!canAccept" />
      <Button label="Pay" @click="actionPay" :disabled="!canPay" />
    </div>
    <DataTable :value="listDataService" :lazy="true" class="p-datatable-responsive" data-key="id" dataKey="id"
      @page="onPage($event)" :paginator="pagination" :totalRecords="totalRecords" :rows="paginationRows"
      :loading="loading" :first="firstRecordIndex" :scrollable="scrollHeight !== '' ? true : false"
      :scrollHeight="scrollHeight" :autoLayout="true" filterMatchMode="startsWith"
      :rowsPerPageOptions="$constants.LIST_OPTION_COMMON.PER_PAGE_OPTIONS" :currentPageReportTemplate="$constants.LIST_OPTION_COMMON.TEXT_TOTAL_ITEM + ' {totalRecords}'
        " :paginatorTemplate="$constants.LIST_OPTION_COMMON.PAGINATOR_TEMPLATE" :selection.sync="selectedRows"
      @row-select="getSelectedIds" @row-unselect="getSelectedIds" @update:selection="getSelectedIds">
      <Column selectionMode="multiple" class="text-center"></Column>
      <Column v-for="c in model.getDisplayFields()" :key="c.key" :field="getField(c)" :header="getLabel(c)"
        :ref="getField(c)" :filterMatchMode="getFilterMatch(c)" :sortable="getSortable(c)"
        :bodyClass="c.class ? 'txt-' + c.class : ''" :bodyStyle="getBodyStyle(c)" :headerStyle="getHeaderStyle(c)"
        :headerClass="c.class ? 'txt-' + c.class : ''">
        <template #body="slotProps">
          <img v-if="getType(c) == 'Image'" :src="getData(c, slotProps.data)" style="width: 40px; height: 40px" />
          <div v-else-if="c.type == 'Text'" v-html="getData(c, slotProps.data)" :style="c.style ? c.style : ''"></div>
          <div v-else-if="getType(c) == 'Custom' || getType(c) == 'Icon'" v-html="getData(c, slotProps.data)"
            :style="c.style ? c.style : ''"></div>
          <div v-else-if="getType(c) == 'CustomUrl' && view_club == true" v-html="callbackCustomUrl(c, slotProps.data)"
            @click="redirectListClub(slotProps.data, $event)" :style="c.style ? c.style : ''"></div>
          <div v-else-if="getType(c) == 'CustomUrl'" v-html="callbackCustomUrl(c, slotProps.data)"
            @click="redirectListClub(slotProps.data, $event)" :style="c.style ? c.style : ''"></div>
          <div v-else-if="getType(c) == 'Number'" v-html="callbackFormatPrice(c, slotProps.data)" class="text-right">
          </div>
          <Checkbox v-else-if="getType(c) == 'Checkbox'" v-model="slotProps.data[slotProps.column.field]" :binary="true"
            @change="onInputChange($event, slotProps.data, c)" />
          <div v-else>
            <div v-if="c.custom">
              <Avatar v-if="c.custom == 'image'" :image="getData(c, slotProps.data)" size="xlarge" />
              <div v-if="c.custom == 'SelectionText'" v-html="callbackDataSelect(c, slotProps.data)"></div>
              <!-- <div
                v-if="c.custom == 'CheckboxId'"
                class="custom-control custom-checkbox"
              >
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="customCheck1"
                  :value="slotProps.data.item_id"
                />
                <label class="custom-control-label" for="customCheck1"></label>
              </div> -->
            </div>
            <span v-else v-html="getData(c, slotProps.data)"
              :class="getCustomClass(c, slotProps.data[c.key], slotProps.data)"></span>
          </div>
        </template>
        <template v-if="c.filter" #filter>
          <InputText v-if="c.filter.type == 'input'" type="text" v-model="filters[getField(c)]" class="p-column-filter"
            :placeholder="$CoreService.getFilterPlaceHolder(c)" @keyup="onFilter($event, c.filter.type, c.key)" />
          <Dropdown :key="countDropdown" v-if="c.filter.type == 'select'" v-model="filters[getField(c)]"
            :options="getFilterOptions(c.key)" :optionLabel="c.filter.optionLabel" :optionValue="c.filter.optionKey"
            :placeholder="$CoreService.getFilterPlaceHolder(c)" class="p-column-filter" :showClear="true"
            @change="onFilter($event, c.filter.type, c.key)">
            <template #option="slotProps">
              <div class="p-clearfix">
                <span :class="getCustomClass(
                  c,
                  slotProps.option[c.filter.optionKey],
                  slotProps.data
                )
                  ">{{ slotProps.option[c.filter.optionLabel] }}</span>
              </div>
            </template>
          </Dropdown>
        </template>
      </Column>
      <template #empty>
        {{ $t('datatable.empty') }}
      </template>
      <template #loading>
        {{ $t('datatable.loading') }}
      </template>
    </DataTable>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import gql from 'graphql-tag';
import DataServices from '@/core/DataServices';

export default {
  props: {
    model: Object,
    tableData: Array,
    getFilterOptions: Function,
    actions: Object,
    options: Array,
    whereKeyList: Object,
  },
  data() {
    return {
      filters: {},
      countDropdown: 0,
      pagination: true, // true cho phép phân trang
      paginationRows: this.$constants.LIST_OPTION_COMMON
        .PAGINATION_ROWS_DEFAULT, // số dòng trên 1 trang
      scrollHeight: '', // chiều cao của trang danh sách
      loading: true,
      rowsPerPageOptions: [10, 20, 50, 100],
      first: 0,
      totalRecords: 120,
      totalRecords2: 12,
      test: null,
      listDataService: null,
      filtersCustom: [],
      lazyParams: {},
      page_transaction: null,
      firstRecordIndex: 0,
      yearRange:
        new Date().getFullYear() - 100 + ':' + (new Date().getFullYear() + 100),
      yearDOB: new Date().getFullYear() - 100 + ':' + new Date().getFullYear(),
      time_zone_local: moment.tz.guess(true),
      view_club: false,
      selectedRows: [],
      canReject: false,
      canAccept: false,
      canPay: false,
    };
  },
  async created() {
    var year = new Date().getFullYear();
    var yearRange = year - 10 + ':' + (year + 90);
    var yearDOB = year - 100 + ':' + year;
    this.yearRange = yearRange + '';
    this.yearDOB = yearDOB + '';
    this.test = this.tableData;
    var arr_role_clubs = await this.$CoreService.checkPermission(
      this.$constants.KEY_MENU.LIST_REFERRED_HISTORY
    );
    if (arr_role_clubs.indexOf(this.$constants.ROLE.VIEW) < 0) {
      this.view_club = false;
    } else {
      this.view_club = true;
    }
  },
  mounted() {
    this.lazyParams = {
      first: 0,
      rows: this.paginationRows,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    };
    if (!this.$commonFuction.isEmpty(this.$route.query)) {
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)) {
        this.page_transaction = this.$route.query.page_transaction;
        this.lazyParams = localStorage.getItem(this.page_transaction)
          ? JSON.parse(localStorage.getItem(this.page_transaction))
          : {};
        this.firstRecordIndex = this.lazyParams.first;
      }
    }
    this.loading = false;
    this.countDropdown++;
    this.onLazyEvent();
  },
  methods: {
    getSelectedIds() {
      const selectedIds = this.selectedRows.map(row => row.id);
      const selectedItems = this.listDataService.filter(item => selectedIds.includes(item.id));
      let notReject = 0;
      let notAccept = 0;
      let notPay = 0;
      if (selectedItems.length > 0) {
        selectedItems.forEach(item => {
          if (item.status === 'Accepted' || item.status === 'Rejected') {
            notReject++;
            notAccept++;
          }
          if (item.status === 'New' || item.status === 'Rejected' || item.payment_status === 'Paid') {
            notPay++
          }
        });
        if (notReject > 0) {
          this.canReject = false;
        } else {
          this.canReject = true;
        }
        if (notAccept > 0) {
          this.canAccept = false;
        } else {
          this.canAccept = true;
        }
        if (notPay > 0) {
          this.canPay = false;
        } else {
          this.canPay = true;
        }
      } else {
        this.canReject = false;
        this.canAccept = false;
        this.canPay = false;
      }
    },
    async actionReject() {
      const selectedIds = this.selectedRows.map(row => row.id);
      await Promise.all(
        selectedIds.map(id =>
          this.$apollo.mutate({
            mutation: DataServices.updateData('referred_history'),
            variables: {
              data_update: {
                status: 'Rejected',
                updated_at: moment.tz(new Date(), this.time_zone_local),
                updated_by: this.$store.getters.user,
              },
              where_key: {
                id: { _eq: id },
              },
            },
          })
        )
      );
      this.onLazyEvent();
      this.selectedRows = [];
      this.canReject = false;
      this.canAccept = false;
      this.canPay = false;
    },
    async actionAccept() {
      const selectedIds = this.selectedRows.map(row => row.id);
      await Promise.all(
        selectedIds.map(id =>
          this.$apollo.mutate({
            mutation: DataServices.updateData('referred_history'),
            variables: {
              data_update: {
                status: 'Accepted',
                updated_at: moment.tz(new Date(), this.time_zone_local),
                updated_by: this.$store.getters.user,
              },
              where_key: {
                id: { _eq: id },
              },
            },
          })
        )
      );
      this.onLazyEvent();
      this.selectedRows = [];
      this.canReject = false;
      this.canAccept = false;
      this.canPay = false;
    },
    async actionPay() {
      const selectedIds = this.selectedRows.map(row => row.id);
      const selectedItems = this.listDataService.filter(item => selectedIds.includes(item.id));
      await Promise.all(
        selectedIds.map(id =>
          this.$apollo.mutate({
            mutation: DataServices.updateData('referred_history'),
            variables: {
              data_update: {
                payment_status: 'Paid',
                updated_at: moment.tz(new Date(), this.time_zone_local),
                updated_by: this.$store.getters.user,
              },
              where_key: {
                id: { _eq: id },
              },
            },
          })
        )
      );
      await Promise.all(
        selectedItems.map(async item => {
          await this.$apollo.mutate({
            mutation: DataServices.insertData('point_history'),
            variables: {
              objects: {
                uid: item.ref_uid,
                amount: item.earn_amount,
                description: 'Reward - Billing',
                updated_at: moment.tz(new Date(), this.time_zone_local),
                created_by: this.$store.getters.user,
                type: (item.type === 2 ? 1 : 2),
                object_id: item.rental_order_id,
                status: 'ST002'
              },
            }
          });
          const userInfo = await this.$CoreService.getUsersById(item.ref_uid);
          // point_wallet
          const point_wallet = userInfo.point_wallet + (item.earn_amount);
          this.$apollo.mutate({
            mutation: DataServices.updateData('users'),
            variables: {
              'data_update': {
                point_wallet: point_wallet,
                updated_by: this.$store.getters.user,
              },
              'where_key': {
                'id': { '_eq': item.ref_uid }
              }
            }
          });
        })
      );
      this.onLazyEvent();
      this.selectedRows = [];
      this.canReject = false;
      this.canAccept = false;
      this.canPay = false;
    },
    callbackCustomUrl(c, data) {
      var text = '';
      switch (c.key) {
        case 'club_html':
          if (
            data.view_users_clubs_expiration_aggregate &&
            data.view_users_clubs_expiration_aggregate.aggregate
          ) {
            var count_club =
              data.view_users_clubs_expiration_aggregate.aggregate.count;
            if (this.view_club == true) {
              text =
                '<a class="txt-link" id="list-users-clubs" :data-id="' +
                data.id +
                '">' +
                count_club +
                '</a>';
            } else {
              text = count_club;
            }
          } else {
            text = 0;
          }
          break;
        default:
          break;
      }
      // this.date_now
      return text;
    },
    callbackFormatPrice(c, data) {
      if (c.key === 'order_amount') {
        return `$${this.$commonFuction.numberFormat(data.order_amount, 2, '.', ',')}`;
      }
      if (c.key === 'earn_amount') {
        return `$${this.$commonFuction.numberFormat(data.earn_amount, 2, '.', ',')}`;
      }
    },
    select_date(event, col_name) {
      if (
        this.filters[col_name][0] !== null &&
        this.filters[col_name][1] !== null
      ) {
        this.$emit('filter_date', {
          data: this.filters[col_name],
          col: col_name,
        });
      }
    },
    getLabel(col) {
      if (col.label) return col.label;
      else return col.name;
    },
    getType(col) {
      if (col.display?.list?.mode == 'custom') {
        return 'Custom';
      }
      switch (col.type) {
        case 'String':
        case 'Text':
        case 'Computed':
          if (col.inputOptions?.mode == 'Image') {
            return 'Image';
          }
          if (col.inputOptions?.mode == 'selection') {
            return 'Select';
          }
          if (col.inputOptions?.mode == 'currency') {
            return 'Currency';
          }
          if (col.inputOptions?.mode == 'icon') {
            return 'Icon';
          }
          return 'Input';
        case 'numeric':
        case 'ShadowField':
        case 'number':
          if (col.inputOptions?.mode == 'currency') {
            return 'Currency';
          } else if (col.inputOptions?.mode == 'percentage') {
            return 'Percentage';
          } else {
            return 'Number';
          }
        case 'Selection':
          return 'Select';
        case 'Checkbox':
          return 'Checkbox';
        default:
          return col.type;
      }
    },
    cannotEdit(col) {
      if (col.edit && col.edit.edit == false) return true;
      return false;
    },
    onInputChange(value, data, f) {
      if (f.onChange) f.onChange(data).bind(this);
      this.$emit('onDataChange', data, f);
    },
    toggle(event) {
      this.$refs.op.toggle(event);
    },
    getCustomClass(col, data, rowData) {
      if (col.displayClass) return col.displayClass(data, rowData);
      return '';
    },
    getField(col) {
      return col.key;
    },
    getHeaderStyle(col) {
      var style = 'text-align:center;';
      if (col.width) style += 'width: ' + col.width + 'em;';
      else if (col.name === 'stt' || col.name === 'STT') style += 'width: 3em;';
      else if (col.type === 'image' || col.type === 'Image')
        style += 'width: 6em;';
      return style;
    },
    getBodyStyle(col) {
      var style = '';
      if (col.width) style = 'width: ' + col.width + 'em;';
      else if (col.name === 'stt' || col.name === 'STT')
        style = 'text-align:center; width: 3em;';
      else if (col.type === 'image' || col.type === 'Image')
        style = 'width: 6em;';
      return style;
    },
    getData(col, row) {
      var value = '';
      if (col.type == 'Date' && row[col.key]) {
        value = moment.tz(row[col.key], this.time_zone_local).format('LL');
        // value = moment.tz(row[col.key], this.time_zone_local).format("DD/MM/yyyy");
      } else if (col.type == 'Datetime' && row[col.key]) {
        value = moment
          .tz(row[col.key], this.time_zone_local)
          .format('ll HH:mm');
        // value = moment.tz(row[col.key], this.time_zone_local).format("HH:mm - DD/MM/yyyy");
      } else if (col.type == 'CustomDate' && row[col.key]) {
        value = moment
          .tz(row[col.key], this.time_zone_local)
          .format('HH:mm - DD/MM/yyyy');
      } else if (col.type == 'Hour' && row[col.key]) {
        value = moment.tz(row[col.key], this.time_zone_local).format('HH:mm');
      } else if (col.type == 'Selection') {
        var lists = [];
        if (col.options !== undefined) {
          lists = col.options;
        } else if (
          col.models !== undefined &&
          this.options[col.key] !== undefined
        ) {
          lists = this.options[col.key];
        }
        if (lists && lists.length) {
          var objResult = lists.filter((a) => a.value == row[col.key]);
          if (
            objResult !== undefined &&
            Object.keys(objResult) &&
            Object.entries(objResult).length
          ) {
            value = objResult[Object.keys(objResult)].label;
          }
        }
      } else {
        if (col.type == 'Text' && row[col.key] && row[col.key].length > 100) {
          var result =
            row[col.key].substr(0, row[col.key].lastIndexOf(' ', 100)) + '...';
          value = result;
        }
        if (this.getType(col) == 'Currency') {
          if (row[col.key] == null) row[col.key] = 0;
          value = this.formatCurrency(row[col.key]);
        }
        if (this.getType(col) == 'Percentage') {
          if (row[col.key] == null) row[col.key] = `0%`;
          value = row[col.key] + '%';
        }
        value = row[col.key];
      }
      if (col.style)
        value = '<abbr style="' + col.style + '">' + value + '<abbr/>';
      else if (col.options) {
        var filtered = col.options.filter((a) => a.value === row[col.key]);
        if (
          Object.keys(filtered) &&
          Object.entries(filtered).length &&
          filtered[0].style
        ) {
          value =
            '<abbr style="' + filtered[0].style + '">' + value + '<abbr/>';
        }
      }
      return value;
    },
    getFilterMatch(col) {
      var filterMatch = 'startWith';
      if (col.filter && col.filter.match) {
        filterMatch = col.filter.match;
      }
      return filterMatch;
    },
    getFilterPlaceHolder(col) {
      if (col.filter.placeHolder) {
        return col.filter.placeHolder;
      } else if (col.filter.type == 'select') {
        return `Chọn`;
      } else if (col.filter.type == 'input') {
        return `Input`;
      } else if (col.filter.type == 'DateRange') {
        return `Choose`;
      } else if (col.filter.type == 'Date') {
        return `Choose`;
      } else {
        return ``;
      }
    },
    getSortable(col) {
      return col.sortable && col.sortable == true ? true : false;
    },
    getIcon(iconName) {
      return `pi pi-${iconName}`;
    },
    getDisabled(disabled = false) {
      return disabled;
    },
    actionsClicked(key, action, rowData) {
      this.$emit('action-click', {
        originalEvent: event,
        action: action,
        key: key,
        data: rowData,
        lazyParams: this.lazyParams,
      });
    },
    getClass(type) {
      switch (type) {
        case 'add':
          return 'p-button-add';
        case 'delete':
          return 'p-button-danger';
        case 'edit':
          return 'p-button-edit';
        case 'adddebt':
          return 'p-button-edit';
        case 'add-Debt':
          return 'p-button-add';
        case 'editcustom':
          return 'p-button-edit';
        case 'addcustom':
          return 'p-button-add';
      }
    },
    formatCurrency(value) {
      return value.toLocaleString('vi-VN', {
        style: 'currency',
        currency: 'VND',
      });
    },
    callbackDataSelect(c, data) {
      var text = '';
      switch (c.key) {
        // key la cai name
        case 'type':
          if (data.type === 2) {
            text = 'Rent';
          }
          if (data.type === 3) {
            text = 'Buy';
          }
          break;
        case 'status':
          if (data.status === 'New') {
            text =
              '<select class="form-select" name="status"><option value="New">New</option><option value="Accepted">Accepted</option><option value="Rejected">Rejected</option></select>';
          }
          if (data.status === 'Accepted' || data.status === 'Rejected') {
            text = `<div class="fake-input">${data.status}</div>`;
          }
          break;
        case 'payment_status':
          if (data.status === 'Rejected') {
            text = '<div class="fake-input text-left">-</div>';
          } else if (data.status === 'Accepted') {
            if (data.payment_status === 'Paid') {
              text = '<div class="fake-input">Paid</div>';
            } else {
              text =
                '<select class="form-select" name="payment_status"><option value="New">New</option><option value="Paid">Paid</option></select>';
            }
          } else {
            text = '<div class="fake-input">&nbsp;</div>';
          }
          break;
        case 'active':
          if (data.active == true) {
            text = `<i style="color: green" class="pi pi-check icon"></i>`;
          } else {
            text = `<i style="color: red" class="pi pi-times icon"></i>`;
          }
          break;

        default:
      }
      return text;
    },
    async dataList(lazyParams) {
      var offset = lazyParams.first;
      var limit = lazyParams.rows;
      var gqLQueryList = gql`
        query getRefHistory(
          $where_key: ref_history_bool_exp!
          $offset: Int
          $limit: Int
          $orderBy: [ref_history_order_by!]
        ) {
          ref_history(
            where: $where_key
            offset: $offset
            limit: $limit
            order_by: $orderBy
          ) {
            id
            type
            order_amount
            earn_amount
            updated_by
            updated_at
            ref_uid
            uid
            rental_order_id
            status
            payment_status
            ref {
              fullname
            }
            user {
              fullname
            }
            order {
              code
            }
          }
        }
      `;
      var where = {
        deleted: { _eq: false },
      };

      var filters = lazyParams.filters;
      if (filters) {
        for (const [key, value] of Object.entries(filters)) {
          if (value.type_input == 'input') {
            if (key === 'user_name_by_key') {
              if (!where.user) {
                where.user = {};
              }
              where.user['fullname'] = {
                _iregex: this.$commonFuction.search(value.value),
              };
            } else if (key === 'ref_name_by_key') {
              if (!where.ref) {
                where.ref = {};
              }
              where.ref['fullname'] = {
                _iregex: this.$commonFuction.search(value.value),
              };
            } else if (key === 'order_code_by_key') {
              if (!where.order) {
                where.order = {};
              }
              where.order['code'] = {
                _iregex: this.$commonFuction.search(value.value),
              };
            } else {
              where[key] = { _iregex: this.$commonFuction.search(value.value) };
            }
          } else if (value.type_input == 'select') {
            if (value.value !== undefined && value.value !== null) {
              where[key] = { _eq: value.value };
            }
          }
        }
      }
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
          offset: offset,
          limit: limit,
          orderBy: { created_at: 'desc' },
        },
      });
      var listData = resData.data.ref_history;
      var gqLQueryCount = gql`
        query countRefHistory($where_key: ref_history_bool_exp!) {
          ref_history_aggregate(where: $where_key) {
            aggregate {
              count
            }
          }
        }
      `;
      var countRes = await this.$apollo.query({
        query: gqLQueryCount,
        variables: {
          where_key: where,
        },
      });
      var total = countRes.data.ref_history_aggregate.aggregate.count;

      var dataRes = {
        listData: listData,
        total: total,
      };
      return dataRes;
    },
    onLazyEvent() {
      this.lazyParams.filters = this.filtersCustom;
      this.loading = true;
      var that = this;
      this.dataList(this.lazyParams).then(async (data) => {
        if (data.listData.length < 1) {
          that.listDataService = data.listData;
          that.totalRecords = data.total;
          that.loading = false;
        }
        var stt = this.lazyParams.first;
        for (var i = 0; i < data.listData.length; i++) {
          var itemData = data.listData[i];
          stt++;
          data.listData[i].stt = stt;

          if (itemData.updated_by) {
            const userInfo = await this.getUser(itemData.updated_by);
            data.listData[i].updated_by_key = userInfo.name;
          }
          if (itemData.ref) {
            data.listData[i].ref_name_by_key = data.listData[i].ref.fullname;
          }
          if (itemData.user) {
            data.listData[i].user_name_by_key = data.listData[i].user.fullname;
          }
          if (itemData.order) {
            data.listData[
              i
            ].order_code_by_key = `<a class="text-decoration-underline" href="/admin/list-rental_order/view/${data.listData[i].order.code}" target="_blank">${data.listData[i].order.code}</a>`;
          }

          data.listData[i].updated_at = this.formatDate(
            data.listData[i].updated_at
          );
        }
        that.listDataService = data.listData;
        that.totalRecords = data.total;
        that.loading = false;
      });
    },
    async getUser(id) {
      var { data } = await this.$apollo.query({
        query: DataServices.getList('users'),
        variables: {
          where_key: {
            id: { _eq: id },
          },
        },
        fetchPolicy: 'network-only',
      });
      return {
        name: data.users[0].fullname,
        email: data.users[0].email,
      };
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    },

    formatDateUpdate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year} `;
    },
    onPage(event) {
      this.lazyParams = event;
      this.onLazyEvent();
    },
    async onFilter(event, type_input, key) {
      this.tableData = this.test;
      if (type_input == 'DateRange') {
        if (this.filters[key] !== null && this.filters[key][1] == null) {
          return false;
        }
      }
      this.filtersCustom[key] = await this.$CoreService.convertFilter(
        type_input,
        key,
        this.filters
      );
      this.lazyParams.first = 0;
      this.onLazyEvent();
    },
  },
};
</script>
<style lang="scss">
.p-paginator-bottom {
  padding: 0 !important;
}

.p-inputtext {
  width: 100%;
}

.p-button-label {
  color: white;
}

.box-header-table button {
  background-color: #ffdf01;
  color: #000000;
  border: 0;
  padding: 13px 35px;
}

.box-header-table button:hover {
  background-color: #ffdf01;
  color: #000000;
  opacity: 0.8;
}

.box-header-table button:disabled {
  background-color: #f2f3f7;
  color: #666666;
}

.box-header-table .p-button:enabled:hover {
  background-color: #ffdf01;
  color: #000000;
  opacity: 0.7;
  border-color: unset;
}

.box-header-table button .p-button-label {
  color: #000000;
  font-weight: 600;
  line-height: 1;
}

.text-decoration-underline {
  text-decoration: underline;
}

.form-select {
  width: 100%;
  padding: 8px 5px;
  border-radius: 4px;
  border: 1px solid #d4d4d4;
  height: 40px;
  line-height: 1;
}

.fake-input {
  width: 100%;
  border: 1px solid #d4d4d4;
  background: #eeeeee;
  border-radius: 4px;
  padding: 11px 5px;
  color: #666666;
  height: 40px;
  line-height: 1;
}

.gap-3 {
  gap: 1rem;
}

.p-datatable .p-datatable-tbody>tr.p-highlight {
  background: rgb(221 218 218);
  color: unset;
}

// .custom-control.custom-checkbox {
//   padding-left: 18px;
//   min-height: 18px;
// }

// .custom-control-label {
//   position: unset;
// }

// .custom-control-label::before,
// .custom-control-label::after {
//   width: 18px;
//   height: 18px;
//   left: 50%;
//   transform: translateX(-50%);
// }

// .custom-control-input:checked ~ .custom-control-label::before {
//   background-color: #ffdf01;
//   border-color: #ffdf01;
// }

// .custom-control-label::after {
//   background: unset;
// }

// .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
//   background-image: url('data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2718%27 height=%2718%27 fill=%27currentColor%27 class=%27bi bi-check%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z%27/%3E%3C/svg%3E');
// }</style>